import { EllipsisOutlined } from "@ant-design/icons"
import { Dropdown, Flex, Switch, Typography } from "antd"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../../Components/Button"
import { dateFormat } from "../../../../Utils/utils"

import "./PerkCard.less"

const { Text, Link } = Typography

const PerkCard = ({ perk, onSelectRow, onToggleVisibility }) => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={16} className="perk-card">
      <div className="card-header">
        <Flex align="center" gap={8} style={{ minWidth: 0 }}>
          <Text strong ellipsis style={{ fontSize: 16 }}>
            {perk?.partner_name || "-"}
          </Text>
        </Flex>
        <Flex align="center" gap={4}>
          <Switch
            checked={!!perk?.is_visible}
            data-testid={`perk-row-visible-switch-${perk?.id}`}
            onClick={(_, e) => {
              e?.stopPropagation?.()
              onToggleVisibility?.(perk)
            }}
          />
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "comment",
                  label: t("Add comment"),
                  "data-testid": `perk-action-comment-${perk?.id}`
                },
                { key: "edit", label: t("Edit"), "data-testid": `perk-action-edit-${perk?.id}` },
                {
                  key: "delete",
                  label: t("Delete"),
                  danger: true,
                  "data-testid": `perk-action-delete-${perk?.id}`
                }
              ],
              onClick: ({ key, domEvent }) => {
                domEvent?.stopPropagation?.()
                onSelectRow?.(perk, key)
              }
            }}
          >
            <ButtonComponent
              type="text"
              icon={<EllipsisOutlined />}
              onClick={(e) => e.stopPropagation()}
              data-testid={`perk-row-actions-dropdown-${perk?.id}`}
            />
          </Dropdown>
        </Flex>
      </div>

      <div className="fields-list">
        <div className="data-block">
          <Text type="secondary" strong>
            {t("Created")}
          </Text>
          <Text strong className="value">
            {perk?.created ? dayjs(perk.created).format(dateFormat) : "-"}
          </Text>
        </div>
        <div className="data-block">
          <Text type="secondary" strong>
            {t("Partner website")}
          </Text>
          {perk?.partner_website ? (
            <Link
              href={perk.partner_website}
              target="_blank"
              rel="noopener noreferrer"
              className="value"
            >
              {perk.partner_website.replace(/^https?:\/\//, "")}
            </Link>
          ) : (
            <Text strong className="value">
              -
            </Text>
          )}
        </div>
        <div className="data-block">
          <Text type="secondary" strong>
            {t("Promocode")}
          </Text>
          <Text strong className="value">
            {perk?.promocode || "-"}
          </Text>
        </div>
        <div className="data-block">
          <Text type="secondary" strong>
            {t("URL")}
          </Text>
          {perk?.url ? (
            <Link href={perk.url} target="_blank" rel="noopener noreferrer" className="value">
              {perk.url.replace(/^https?:\/\//, "")}
            </Link>
          ) : (
            <Text strong className="value">
              -
            </Text>
          )}
        </div>
      </div>

      {perk?.offer_details && (
        <div className="data-block">
          <Text type="secondary" strong>
            {t("Offer details")}
          </Text>
          <Text strong className="value-multi">
            {perk.offer_details}
          </Text>
        </div>
      )}

      {perk?.description && (
        <div className="data-block">
          <Text type="secondary" strong>
            {t("Description")}
          </Text>
          <Text strong className="value-multi">
            {perk.description}
          </Text>
        </div>
      )}

      {perk?.comment && (
        <div className="data-block">
          <Text type="secondary" strong>
            {t("Comments")}
          </Text>
          <Text strong className="value-multi">
            {perk.comment}
          </Text>
        </div>
      )}
    </Flex>
  )
}

export default PerkCard
